export const notifications = {
  notifications: {
    prompt: {
      title: "Ontvang belangrike kennisgewings",
      description: "Aktiveer kennisgewings om waarskuwings oor spesiale promosies, wedstryduitslae en nuus te ontvang.",
      error: "'n Fout het plaasgevind tydens die aktivering van kennisgewings",
      later: "Later",
      enable: "Aktiveer kennisgewings",
      activating: "Aktiveer...",
    },
  },
};
